<template>
  <div>
      <el-button v-show="false" id="btnEcdocSaved" type="default" @click="btnEcdocSavedClick" />
      <el-button v-show="false" id="windowOpen" type="default" @click="windowOpen" />
  </div>
</template>
<script>
export default {
    name: 'H5Office',
    props: {
        officeType: {
            type: String,
            default: function () {
                return 'yzh5'
            }
        }
    },
    data: function () {
        return {
            loginUser: this.$store.getters.loginUser,
            doctimer: null,
            tSessionId: null,
            openType: null,
            WFBodyDocId: '',
            fanwen_url: ''
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('btnOpenWordClick', this.btnOpenWordClick)
        this.$bus.on('btnEditAttachClick', this.btnEditAttachClick)
        this.$bus.on('btnModifyFlTypeClick', this.btnModifyFlTypeClick)
        this.$bus.on('btnNoTitleModifyFlTypeClick', this.btnNoTitleModifyFlTypeClick)
    },
    beforeDestroy: function () {
        this.$bus.off('btnOpenWordClick', this.btnOpenWordClick)
        this.$bus.off('btnEditAttachClick', this.btnEditAttachClick)
        this.$bus.off('btnModifyFlTypeClick', this.btnModifyFlTypeClick)
        this.$bus.off('btnNoTitleModifyFlTypeClick', this.btnNoTitleModifyFlTypeClick)
    },
    mounted: function () {},
    methods: {
        /**
       * redTitle 模式 更换红头事件 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        btnModifyFlTypeClick($scope) {
            this.validateEditModeWithPrompt($scope)
        },
        /**
       * NoTitle 模式 套红头事件 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        btnNoTitleModifyFlTypeClick($scope) {
            this.validateEditModeWithPrompt($scope)
        },
        /**
       * 查询红头模版前的校验操作 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        validateEditModeWithPrompt($scope) {
            // 非内嵌需带上此校验
            if ($scope.InlineTextEditor) {
                return
            }
            let confirmMessage, officeType
            if ($scope.wfInstance.passenger.docEditMode === 'NoTitle') {
                if ($scope.vo.signedFileName) {
                    // 简化条件判断
                    // confirmMessage = '该公文已经盖章，重新编辑正文后需要重新盖章！<br>是否继续？'
                    confirmMessage = this.$tx('ecoa.webOffice.signedFileNameConfirm', '该公文已经盖章，重新编辑正文后需要重新盖章！') + '<br>' + this.$tx('ecoa.webOffice.signedFileNameConfirm2', '是否继续？')
                    officeType = 'RedliningOnce' // 如果是在NoTitle模式下，并且有签名文件，则使用'RedliningOnce'
                } else if ($scope.wfInstance.haveDoc === 2) {
                    // confirmMessage = '该公文已经套过红！<br>是否继续？'
                    confirmMessage = this.$tx('ecoa.webOffice.haveDocConfirm', '该公文已经套过红！') + '<br>' + this.$tx('ecoa.webOffice.signedFileNameConfirm2', '是否继续？')

                    officeType = 'Redlining' // 如果是NoTitle模式下且再次套红（haveDoc为2），则使用'Redlining'
                } else {
                    officeType = 'Redlining' // 否则默认使用'Redlining'
                }
            } else {
                if ($scope.vo.signedFileName) {
                    // confirmMessage = '该公文已经盖章，重新编辑正文后需要重新盖章！<br>是否继续？'
                    confirmMessage = this.$tx('ecoa.webOffice.signedFileNameConfirm', '该公文已经盖章，重新编辑正文后需要重新盖章！') + '<br>' + this.$tx('ecoa.webOffice.signedFileNameConfirm2', '是否继续？')

                    officeType = 'OpenTwoDoc' // 如果不是NoTitle模式下，且有签名文件，则使用'OpenTwoDoc'
                } else {
                    officeType = 'OpenTwoDoc' // 否则默认使用'OpenTwoDoc'
                }
            }

            if (confirmMessage) {
                this.$confirm(confirmMessage, this.$tx('common.confirmOperate', '确认操作'), { type: 'warning', dangerouslyUseHTMLString: true })
                    .then(() => {
                        this.ModifyFlTypeClick($scope, officeType)
                    })
                    .catch(() => {
                        return
                    })
            } else {
                // 如果没有需要确认的消息，则直接调用函数
                this.ModifyFlTypeClick($scope, officeType)
            }
        },
        /**
       * 选择红头事件 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        ModifyFlTypeClick($scope, officeType) {
            this.fetchFwmbTemplateData($scope).then((res) => {
                if (res.code === 'success') {
                    // 匹配文件字号相同的红头模版，并设置所有模板的value和text属性
                    let mbList = []
                    if ($scope.vo && $scope.vo.flWord) {
                        // 过滤出文件字号相同的红头模版
                        mbList = res.body.listdata.filter((item) => item.fileWord === $scope.vo.flWord)

                        // 如果找到了匹配的模版，则替换res.body.listdata
                        if (mbList.length > 0) {
                            res.body.listdata = mbList
                        }
                    }
                    // 无论是否找到了匹配的模版，都设置所有模板的value和text属性
                    res.body.listdata.forEach((item) => {
                        item.value = item.id
                        item.text = item.name
                    })

                    if (res.body.listdata.length > 1) {
                        this.$bus.emit(
                            'openListitemDialog',
                            this.$tx('ecoa.webOffice.selectRedModule', '选择红头模板'),
                            res.body.listdata,
                            (rst) => {
                                if (rst.code === 'success') {
                                    const gwmb = res.body.listdata.filter((item) => {
                                        if (item.id === rst.value) return true
                                    })
                                    this.validateAndEditFwmbTemplate($scope, gwmb, officeType)
                                }
                            },
                            $scope.vo.gwmbId,
                            this.$tx('ecoa.webOffice.redTitleModule', '红头模板'),
                            this.$tx('ecoa.webOffice.selectRedModule2', '请选择红头模板')
                        )
                    } else if (res.body.listdata.length === 1) {
                        // 调用选择模版后处理方法

                        this.validateAndEditFwmbTemplate($scope, res.body.listdata, officeType)
                    }
                } else {
                    // this.$alert(res.message,  '操作提示', { type: 'error' })
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
       * 请求发文模版数据 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        fetchFwmbTemplateData($scope) {
            return this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: { orderBy: 'sortNo,name' },
                data: [
                    { compare: '=', field: 'orgCode', value: $scope.wfInstance.orgCode },
                    { compare: '=', field: 'status', value: 1 }
                ],
                url: 'gwgl/fwmb/querydata?urlsearch=mbType:fwmb'
            })
        },
        /**
       * 拿到红头模版后的调用编辑正文操作 --  非wpsjs、ecexe 通用方法
       * @param {*} $scope
       */
        validateAndEditFwmbTemplate($scope, gwmb, officeType) {
            $scope.vo.flWord = gwmb[0].fileWord
            $scope.vo.flFormName = gwmb[0].formTitle
            $scope.vo.flRedTitle = gwmb[0].fileHeader
            $scope.vo.gwmbId = gwmb[0].id
            $scope.vo.flType = gwmb[0].name
            this.btnOpenWordClick($scope, officeType)
        },
        /**
       * 附件编辑正文事件
       * @param {*} $scope
       */
        btnEditAttachClick(attach, officeType) {
            const $scope = this.$vnode.context
            const downUrl = process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + attach.busiDataId + '&attachsName=' + encodeURIComponent(attach.fileName) + '&attachsType=ATTACH'

            this.officeType = officeType
            if (this.officeType === 'wpsh5') {
                this.btnOpenWpsEditorClick($scope, [], downUrl, attach.fileId || attach.id, attach.fileVer)
            } else if (this.officeType === 'yzh5') {
                this.btnOpenYzdocEditorClick($scope, [], downUrl, attach.fileId || attach.id, attach.fileVer)
            } else if (this.officeType === 'ech5') {
                this.btnOpenEcdocEditorClick($scope, [], {}, downUrl, attach.fileId || attach.id, attach.fileVer)
            }
        },
        btnOpenWordClick($scope, openType, fanwen_url) {
            // 编辑文本打开事件
            this.fanwen_url = fanwen_url
            if ($scope.InlineTextEditorShow) {
                return
            }
            this.openType = openType
            $scope.formValidate(() => {
                let bookmarks = []
                if ($scope.wfInstance.haveDoc === 0 || openType === 'OpenTwoDoc' || openType === 'Redlining' || openType === 'RedliningOnce') {
                    bookmarks.push({ bookName: 'FlSubject', bookValue: $scope.vo.flSubject == null ? '' : $scope.vo.flSubject })
                    bookmarks.push({ bookName: 'FlMainSend', bookValue: $scope.vo.flMainSend == null ? '' : $scope.vo.flMainSend })
                    bookmarks.push({ bookName: 'FlSignOrg', bookValue: $scope.vo.flSignOrg == null ? '' : $scope.vo.flSignOrg })
                    bookmarks.push({ bookName: 'Copies', bookValue: $scope.vo.flPrintCount == null ? '' : $scope.vo.flPrintCount + '' })
                    bookmarks.push({ bookName: 'FileCode', bookValue: $scope.vo.flFwzh == null ? '' : $scope.vo.flFwzh })
                    bookmarks.push({ bookName: 'FlCopySend', bookValue: $scope.vo.flCopySend == null ? '' : $scope.vo.flCopySend })

                    // if ($scope.wfInstance.module === 'hytz') {
                    //     bookmarks.push({ bookName: 'StartTime', bookValue: $scope.vo.startTime == null ? '' : $scope.vo.startTime.substring(0, 16) })
                    //     bookmarks.push({ bookName: 'EndTime', bookValue: $scope.vo.endTime == null ? '' : $scope.vo.endTime.substring(0, 16) })
                    //     bookmarks.push({ bookName: 'Address', bookValue: $scope.vo.address == null ? '' : $scope.vo.address })
                    //     bookmarks.push({ bookName: 'Compere', bookValue: $scope.vo.compere == null ? '' : $scope.vo.compere })
                    //     bookmarks.push({ bookName: 'Body', bookValue: $scope.vo.lContent == null ? '' : $scope.vo.Body })
                    //     bookmarks.push({ bookName: 'Leaders', bookValue: $scope.vo.leaders == null ? '' : $scope.vo.leaders })
                    //     bookmarks.push({ bookName: 'tixingshijian', bookValue: $scope.vo.flRegistTime == null ? '' : $scope.vo.flRegistTime.substring(0, 16) })
                    //     bookmarks.push({ bookName: 'flSignOrg', bookValue: $scope.wfInstance.orgName })
                    //     bookmarks.push({ bookName: 'fabushijian', bookValue: $scope.vo.flCreateDate })
                    // }
                }

                // 过滤书签

                if (bookmarks.length > 0) {
                    if ($scope.vo.passenger && $scope.vo.passenger.flTypeOptions) {
                        $scope.vo.passenger.flTypeOptions.forEach((item) => {
                            if (item.gwmb.id === $scope.vo.gwmbId) {
                                bookmarks = bookmarks.filter((ite) => {
                                    if (item.gwmb.fileBookMark.indexOf(ite.bookName) !== -1) {
                                        return ite
                                    }
                                })
                            }
                        })
                    }
                }

                const WFBusiDataId = $scope.vo.id
                const WFBodyDocId = $scope.wfInstance.bodyDocId
                this.WFBodyDocId = WFBodyDocId
                let saveAs = WFBodyDocId + '.doc'
                if (openType === 'NoTracks') {
                    saveAs = 'NoTracks_' + saveAs
                } else if (openType === 'Redlining' || (openType === 'RedliningOnce' && $scope.wfInstance.passenger.docEditMode === 'NoTitle')) {
                    saveAs = 'RedTitle_' + saveAs
                }
                let fileId = ''
                let fileVer = ''
                let downUrl = ''
                let insertFileUrl = '' // 指定的红头模板'

                if ($scope.wfInstance.haveDoc === 0) {
                    // 初始无正文
                    if (this.fanwen_url) {
                        downUrl = process.env.VUE_APP_BASE_API.substring(1) + this.fanwen_url + '&saveAs=' + saveAs
                    } else if ($scope.wfInstance.passenger.docEditMode === 'NoTitle') {
                        // NoTitle 直接启用空白模版进行正文编辑
                        downUrl = 'templates/Editor.doc?saveAs=' + saveAs
                    } else if ($scope.vo.gwmbId && $scope.vo.gwmbId !== null && $scope.vo.gwmbId !== '') {
                        downUrl = process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/fwmb/download?id=' + $scope.vo.gwmbId + '&dataField=fileContent&nameField=mbFileName&saveAs=' + saveAs
                    } else {
                        downUrl = 'templates/Editor.doc?saveAs=' + saveAs
                    }
                } else if (openType === 'NoTracks') {
                    if ($scope.noTracksFile && $scope.noTracksFile.fileName) {
                        // 清稿在优先选择已清稿文件
                        downUrl = process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=NoTracks_' + WFBodyDocId + '.doc&attachsType=BODY&saveAs=' + saveAs
                    } else {
                        // 编辑正文取源文件
                        downUrl = process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY&saveAs=' + saveAs
                    }
                } else if (openType === 'Redlining' || openType === 'RedliningOnce') {
                    if ($scope.noTracksFile && $scope.noTracksFile.fileName && $scope.wfInstance.passenger.docEditMode === 'NoTitle') {
                        downUrl = process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=NoTracks_' + WFBodyDocId + '.doc&attachsType=BODY'
                    } else {
                        // 编辑正文取源文件
                        downUrl = process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY'
                    }

                    insertFileUrl = process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/fwmb/download?id=' + $scope.vo.gwmbId + '&dataField=fileContent&nameField=mbFileName&saveAs=' + saveAs
                } else {
                    // 有正文
                    downUrl = process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY&saveAs=' + saveAs
                }
                const bodyDocFiles = $scope.attachments.filter((attach) => {
                    if (attach.fileType === 'BODY' && (attach.originalName.indexOf(WFBodyDocId + '.doc') !== -1 || attach.originalName.indexOf(WFBodyDocId + '.docx') !== -1)) return true
                })

                if (bodyDocFiles.length > 0) {
                    fileId = bodyDocFiles[0].fileId
                    fileVer = bodyDocFiles[0].fileVer
                }

                const data = {}
                let params = {}
                params = {
                    downUrl: downUrl, // 正文地址
                    // fileId: fileId || '',
                    fileId: '',
                    // fileVersionId: fileVer || '',
                    fileVersionId: ''
                }
                if (openType === 'Redlining') {
                    // openType = 'Redlining' // 类型 临时为 test调试
                    data.insertFileUrl = insertFileUrl // 红头模版地址
                    data.bkInsertFile = 'Body' // 套红书签位置
                    data.bookmarks = bookmarks // 书签合集
                    data.fileName = WFBodyDocId + '.doc'
                }

                if (this.officeType === 'wpsh5') {
                    bookmarks.forEach((bookmark) => {
                        bookmark.name = bookmark.bookName
                        bookmark.value = bookmark.bookValue
                        bookmark.type = 'text'
                    })
                    this.btnOpenWpsEditorClick($scope, bookmarks, downUrl, fileId, fileVer)
                } else if (this.officeType === 'yzh5') {
                    this.btnOpenYzdocEditorClick($scope, bookmarks, data, params, openType)
                } else if (this.officeType === 'ech5') {
                    this.btnOpenEcdocEditorClick($scope, bookmarks, data, downUrl, fileId, fileVer)
                }
            })
        },
        btnOpenWpsEditorClick($scope, bookmarks, downUrl, fileId, fileVer) {
            // 打开 wps h5
            let appUrl = location.href.split('#')[0].split('windex.html')[0]
            // 开发调试期间指定地址
            if (appUrl.indexOf('//127') !== -1 || appUrl.indexOf('//192') !== -1) {
                appUrl = 'http://14.18.154.83:9908/'
            }
            downUrl = appUrl + downUrl

            let params = {}
            const WfModule = $scope.wfInstance.module
            const WFBodyDocId = $scope.wfInstance.bodyDocId
            const WFBusiDataId = $scope.vo.id
            // let reloadMsg = '正在重新加载文件，请稍候...'
            let reloadMsg = this.$tx('ecoa.webOffice.reloadMsg', '正在重新加载文件，请稍候...')

            if (downUrl.indexOf('=ATTACH') === -1) {
                // 开
                const flSubject = $scope.vo.flSubject
                params = {
                    module: WfModule,
                    busiDataId: WFBusiDataId,
                    bodyDocId: WFBodyDocId,
                    attachName: flSubject + '.doc',
                    attachType: 'BODY',
                    downUrl: encodeURI(downUrl)
                }
            } else {
                const attachName = downUrl.split('attachsName=')[1].split('&')[0]
                params = {
                    module: WfModule,
                    busiDataId: WFBusiDataId,
                    bodyDocId: WFBodyDocId,
                    attachName: attachName,
                    attachType: 'ATTACH',
                    downUrl: encodeURI(downUrl)
                }
                reloadMsg = this.$tx('ecoa.webOffice.reloadMsg2', '正在保存附件,请稍候...')
            }

            this.$http({
                method: 'GET',
                params: params,
                url: 'wpsOffice/getAppToken'
            }).then((res) => {
                if (res.code === 'success') {
                    this.tSessionId = res.body.tSessionId

                    let editorUrl = './plugins/wpsjs/h5office/editor.html'
                    editorUrl += '?token=' + encodeURI(res.body.accessToken)
                    editorUrl += '&signatureurl=' + encodeURIComponent(res.body.url)

                    const docEditor = window.open(editorUrl) // 打开
                    let setBookmarked = false
                    this.doctimer = setInterval(() => {
                        if (window.wordApp) {
                            if (bookmarks.length > 0 && !setBookmarked) {
                                setBookmarked = true
                                if (bookmarks.length > 0) {
                                    bookmarks.forEach(async (bookmark) => {
                                        try {
                                            await window.wordApp.ActiveDocument.ReplaceBookmark([bookmark])
                                        } catch (e) {
                                            console.log(e)
                                        }
                                    })
                                } else {
                                    window.wordApp.ActiveDocument.TrackRevisions = true // 启用修订
                                }
                            }
                        }

                        if (!docEditor.location.href) {
                            clearInterval(this.doctimer)

                            if (window.wordApp) {
                                window.wordApp.Stack().End()
                            }
                            if (window.fileStatus > 0) {
                                this.$bus.emit('showDoingDialog', reloadMsg)

                                const uploadUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/upload'
                                this.checkWpsEditorFinished($scope, res.body.attachId, uploadUrl, 0, params.attachType)
                            }
                        }
                    }, 500)
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        checkWpsEditorFinished($scope, attachId, uploadUrl, checkCount, attachType) {
            // wps h5 编辑完成
            this.$http({
                method: 'GET',
                url: 'wpsOffice/checkFinished',
                params: { attachId: attachId, uploadUrl: uploadUrl, tSessionId: this.tSessionId, checkCount: checkCount }
            }).then((chkRes) => {
                if (chkRes.code === 'success') {
                    if (chkRes.body.waiting) {
                        setTimeout(() => {
                            this.checkWpsEditorFinished($scope, attachId, uploadUrl, ++checkCount, attachType)
                        }, 1000)
                    } else if (chkRes.body.finished) {
                        this.$bus.emit('closeDoingDialog')
                    } else if (chkRes.body.saved) {
                        if (attachType === 'BODY') {
                            const haveDoc = $scope.wfInstance.haveDoc || $scope.$vnode.context.wfInstance.haveDoc
                            if (haveDoc !== 2 || $scope.vo.signedFileName) {
                                $scope.wfInstance.haveDoc = 2
                                if ($scope.vo.signedFileName) $scope.vo.signedFileName = null
                            }

                            if ($scope.wfInstance.status === -1 || haveDoc === 0) {
                                localStorage.setItem('activeName', 1)
                                $scope.btnSubmitClick('Save')
                            } else {
                                this.$bus.emit('reloadBodyFile')
                                this.$bus.emit('closeDoingDialog')
                            }
                        } else {
                            this.$bus.emit('closeDoingDialog')
                        }
                    }
                } else {
                    this.$bus.emit('closeDoingDialog')
                    this.$alert(chkRes.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        btnOpenYzdocEditorClick($scope, bookmarks, data, params, openType) {
            let appUrl = location.href.split('#')[0].split('windex.html')[0] // 取基地址
            if (appUrl.indexOf('//127') !== -1 || appUrl.indexOf('//192') !== -1) {
                appUrl = 'http://toa.ecinc.com.cn:2028/'
            }
            params.downUrl = appUrl + params.downUrl
            data.insertFileUrl = appUrl + data.insertFileUrl

            // 对空白文档做处理
            if (params.downUrl.indexOf('/Editor.doc') !== -1) {
                params.downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/common/downhttpfile?' + 'saveAs=' + $scope.vo.flSubject.trim() + '.doc&' + 'downurl=' + encodeURIComponent(params.downUrl)
            }

            // 打开 永中 在线编辑
            this.$bus.emit('showDoingDialog', '正在下载文件，请稍候...')
            let requestObj = {}

            if (openType === 'Redlining') {
                // NoTitle
                requestObj = {
                    method: 'POST',
                    url: 'yzOffice/getBodyFileVersionId',
                    data: {
                        ...data,
                        openType: openType // 操作类型
                    },
                    params: params
                }
            } else {
                requestObj = { method: 'GET', url: 'yzOffice/getFileVersionId', params: params }
            }

            console.log(requestObj, 'requestObj.data')
            this.$http(requestObj).then((res) => {
                if (res.code === 'success') {
                    const apiUrl = res.body.apiUrl
                    const appId = res.body.appId
                    const sign = res.body.sign
                    const fileVersionId = res.body.fileVersionId
                    const fileUrl = apiUrl + 'api/edit/file?fileVersionId=' + fileVersionId + '&userRight=0' + '&appId=' + appId + '&userName=' + this.loginUser.personName + '&sign=' + sign
                    this.$bus.emit('closeDoingDialog')
                    this.windowOpen(fileUrl, $scope, fileVersionId, openType)
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                    this.$bus.emit('closeDoingDialog')
                }
            })
        },
        windowOpen(fileUrl, $scope, fileVersionId, openType) {
            const docEditor = window.open(fileUrl)
            this.doctimer = setInterval(() => {
                console.log(docEditor)
                if (docEditor.closed) {
                    clearInterval(this.doctimer)
                    this.$bus.emit('showDoingDialog', '正在重新加载文件，请稍候...')

                    setTimeout(() => {
                        this.checkYzdocEditorFinished($scope, fileVersionId, 0, openType)
                    }, 1000)
                }
            }, 500)
        },
        checkYzdocEditorFinished($scope, fileVersionId, checkCount, openType) {
            const WFBusiDataId = $scope.vo.id
            const WfModule = $scope.wfInstance.module
            let WFBodyDocId = $scope.wfInstance.bodyDocId
            if (openType === 'Redlining') {
                WFBodyDocId = 'RedTitle_' + WFBodyDocId
            }

            this.$http({
                method: 'GET',
                url: 'yzOffice/checkFinished',
                params: { module: WfModule, busiDataId: WFBusiDataId, bodyDocId: WFBodyDocId, fileVersionId: fileVersionId, checkCount: checkCount }
            }).then(
                (chkRes) => {
                    if (chkRes.code === 'success') {
                        if (chkRes.body.waiting) {
                            setTimeout(() => {
                                this.checkYzdocEditorFinished($scope, fileVersionId, ++checkCount, openType)
                            }, 1000)
                        } else if (chkRes.body.finished) {
                            this.$bus.emit('closeDoingDialog')
                        } else if (chkRes.body.saved) {
                            const haveDoc = $scope.wfInstance.haveDoc
                            const signedFileName = $scope.vo.signedFileName

                            if ($scope.wfInstance.passenger.docEditMode === 'NoTitle') {
                                // NoTitle 模式
                                if (!this.openType) {
                                    // 编辑正文且无红头
                                    $scope.wfInstance.haveDoc = 1
                                } else if (this.openType === 'Redlining' || this.openType === 'RedliningOnce') {
                                    // 套红
                                    $scope.wfInstance.haveDoc = 2
                                }
                            } else {
                                // RedTitle 模式
                                $scope.wfInstance.haveDoc = 2
                            }

                            if ($scope.vo.signedFileName) $scope.vo.signedFileName = null

                            // 编辑状态有变化、套红状态有变化、有历史版本时，保存表单重新加载，否则只重新加载正文
                            if (haveDoc !== $scope.wfInstance.haveDoc || signedFileName !== $scope.vo.signedFileName || chkRes.body.uploadAttachList[0].fileVer) {
                                localStorage.setItem('activeName', 1)
                                $scope.btnSubmitClick('Save')
                                $scope.bodyFileEditor = 2
                            } else {
                                this.$bus.emit('reloadBodyFile')
                                this.$bus.emit('closeDoingDialog')
                            }
                        }
                    } else {
                        this.$bus.emit('closeDoingDialog')
                        this.$alert(chkRes.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                    }
                },
                (err) => {
                    this.$bus.emit('closeDoingDialog')
                    this.$alert(err.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                    console.log(err)
                }
            )
        },
        async btnOpenEcdocEditorClick($scope, bookmarks, data, downUrl) {
            let appUrl = location.href.split('#')[0].split('windex.html')[0]
            if (appUrl.indexOf('//127') !== -1) {
                appUrl = 'http://192.168.0.100:9529/'
            }
            downUrl = appUrl + downUrl

            let fileName = $scope.vo.flSubject + '.doc'
            let attachType = 'BODY'

            if (downUrl.indexOf('=ATTACH') !== -1) {
                fileName = downUrl.split('attachsName=')[1].split('&')[0]
                attachType = 'ATTACH'
            }

            // if (this.openType === 'Redlining' || this.openType === 'RedliningOnce') {
            //     fileName = 'RedTitle_' + this.WFBodyDocId + '.doc'
            // }

            let insertFileUrl
            if (data.bkInsertFile && data.insertFileUrl) {
                // 套红，重设下载地址为模板，插入文件为正文
                data.insertFileUrl = appUrl + data.insertFileUrl
                insertFileUrl = downUrl
                downUrl = data.insertFileUrl
                const tSessionId = await this.getSessionId()

                insertFileUrl += '&tSessionId=' + tSessionId
            }
            console.log(downUrl, ' downUrl --- > 598')
            console.log(insertFileUrl, ' insertFileUrl --- > 598')

            this.$bus.emit('showDoingDialog', '正在下载文件，请稍候...')

            this.$http({
                method: 'GET',
                url: 'wopi/getAccessToken',
                params: { downUrl: downUrl, fileName: fileName }
            }).then((res) => {
                if (res.code === 'success') {
                    this.tSessionId = res.body.tSessionId
                    this.$bus.emit('closeDoingDialog')

                    let editorUrl = res.body.editorUrl
                    editorUrl = editorUrl.split('/browser/')[0] + '/browser/dist/ecweboffice/editor.html?url=' + encodeURIComponent(editorUrl)
                    const docEditor = window.open(editorUrl)
                    let setBookmarked = false
                    let bodyInsered = false

                    this.doctimer = setInterval(() => {
                        // 在线编辑代码开始
                        if (!bodyInsered && data.bkInsertFile && data.insertFileUrl) {
                            // 套红

                            console.log(docEditor, 'docEditor --- >561')
                            docEditor.postMessage(JSON.stringify({ MessageId: 'InsertFile', Values: { inserFileBookName: data.bkInsertFile, insertFileUrl: insertFileUrl, bookmarks: bookmarks } }), '*')
                            bodyInsered = true
                            setBookmarked = true
                        } else if (bookmarks.length > 0 && !setBookmarked) {
                            console.log(docEditor, 'docEditor --- >561')

                            docEditor.postMessage(JSON.stringify({ MessageId: 'InsertBookmark', Values: bookmarks }), '*')
                            setBookmarked = true
                        }

                        if (!docEditor.location) {
                            clearInterval(this.doctimer)

                            if (window.fileStatus > 0) {
                                this.$bus.emit('showDoingDialog', reloadMsg)

                                const uploadUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/upload'
                                this.checkEcincEditorFinished($scope, res.body.attachId, uploadUrl, 0, params.attachType)
                            }
                        }
                        // 在线编辑代码结束
                        if (docEditor.closed) {
                            clearInterval(this.doctimer)
                            this.btnEcdocSavedClick(true)
                        }
                    }, 500)

                    let uploadUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/upload'
                    uploadUrl += '?busiDataId=' + $scope.vo.id
                    uploadUrl += '&bodyDocId=' + $scope.wfInstance.bodyDocId
                    uploadUrl += '&module=' + $scope.wfInstance.module
                    let attachsName = ''
                    if (this.openType === 'Redlining' || this.openType === 'RedliningOnce') {
                        attachsName = 'RedTitle_' + this.WFBodyDocId + '.doc'
                    } else if (this.openType === 'NoTracks') {
                        attachsName = 'NoTracks_' + this.WFBodyDocId + '.doc'
                    } else {
                        attachsName = this.WFBodyDocId + '.doc'
                    }
                    uploadUrl += '&attachsName=' + attachsName
                    uploadUrl += '&attachsType=' + attachType
                    uploadUrl += '&topdf=true'
                    uploadUrl += '&saveAs=' + this.WFBodyDocId + '.doc'
                    uploadUrl += '&r=' + Math.random()
                    document.querySelector('#btnEcdocSaved').uploadUrl = uploadUrl
                    document.querySelector('#btnEcdocSaved').checkSave = false
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        getSessionId() {
            return new Promise((resolve, reject) => {
                this.$http({
                    method: 'GET',
                    params: { timeLength: 60 },
                    url: 'base/user/getSessionId'
                }).then((res) => {
                    if (res.code === 'success') {
                        resolve(res.body.tSessionId)
                    } else {
                        reject(res.msg)
                    }
                })
            })
        },
        btnEcdocSavedClick(closed) {
            if (this.officeType !== 'ech5') return

            const messageBtn = document.querySelector('#btnEcdocSaved')
            console.log(messageBtn.srcEvent)
            if (!messageBtn.srcEvent) return
            var msg = messageBtn.srcEvent.data
            if (!msg) {
                return
            } else if (typeof msg === 'string') {
                msg = JSON.parse(msg)
            }
            let checkSave = false
            if (closed && messageBtn.checkSave) {
                checkSave = true
            } else if (msg.MessageId === 'UI_Save') {
                checkSave = true
            } else if (msg.MessageId === 'Doc_ModifiedStatus' && msg.Values.Modified) {
                messageBtn.checkSave = true
                return
            }

            if (checkSave) {
                delete messageBtn.srcEvent.data
                delete messageBtn.checkSave

                const uploadUrl = document.querySelector('#btnEcdocSaved').uploadUrl

                let reloadMsg = this.$tx('ecoa.webOffice.reloadMsg', '正在重新加载文件，请稍候...')
                let attachType = 'BODY'

                if (uploadUrl.indexOf('=ATTACH') !== -1) {
                    reloadMsg = this.$tx('ecoa.webOffice.reloadMsg2', '正在保存附件,请稍候...')
                    attachType = 'ATTACH'
                }
                this.$bus.emit('showDoingDialog', reloadMsg)
                const $scope = this.$vnode.context

                this.checkEcincEditorFinished($scope, this.tSessionId, uploadUrl, 0, attachType)
            } else {
                this.$bus.emit('closeDoingDialog')
            }
        },
        checkEcincEditorFinished($scope, fileId, uploadUrl, checkCount, attachType) {
            if (!this.$vnode.context.vo) $scope = this.$vnode.context.$vnode.context
            const _this = this
            this.$http({
                method: 'GET',
                url: 'wopi/checkFinished',
                params: { fileId: fileId, uploadUrl: uploadUrl, checkCount: checkCount }
            }).then((chkRes) => {
                if (chkRes.code === 'success') {
                    if (chkRes.body.waiting) {
                        setTimeout(() => {
                            this.checkEcincEditorFinished($scope, fileId, uploadUrl, ++checkCount, attachType)
                        }, 1000)
                    } else if (chkRes.body.finished) {
                        this.$bus.emit('closeDoingDialog')
                    } else if (chkRes.body.saved) {
                        if (attachType === 'BODY') {
                            const haveDoc = $scope.wfInstance.haveDoc
                            if (this.openType === 'NoTracks') {
                                // 清稿结束
                                $scope.wfInstance.haveDoc = 1
                                if ($scope.vo.signedFileName) $scope.vo.signedFileName = null
                            } else if (this.openType === 'Redlining' || this.openType === 'RedliningOnce') {
                                // 套红或重新套红
                                $scope.wfInstance.haveDoc = 2
                                if ($scope.vo.signedFileName) $scope.vo.signedFileName = null
                            } else if (this.openType === 'SignedFile') {
                                // 盖章
                                $scope.vo.signedFileName = attachs[0].fileName
                            } else {
                                // 编辑正文
                                if ($scope.wfInstance.passenger.docEditMode === 'NoTitle') {
                                    // NoTitle 模式下 haveDoc 编辑后为 1
                                    $scope.wfInstance.haveDoc = 1
                                } else {
                                    $scope.wfInstance.haveDoc = 2
                                }
                                if ($scope.vo.signedFileName) $scope.vo.signedFileName = null
                            }

                            if (haveDoc === $scope.wfInstance.haveDoc && $scope.wfInstance.haveDoc === 1 && !$scope.noTracksFile && this.openType !== 'NoTracks') {
                                $scope.$message({
                                    type: 'success',
                                    message: '文件已保存成功！',
                                    showClose: true
                                })
                                $scope.btnSubmitClick('AutoSave', (saveRst, a, b, c) => {
                                    if (saveRst) {
                                        _this.$bus.emit('reloadBodyFile')
                                    }
                                })
                            } else {
                                // localStorage.setItem('activeName', 1)
                                // $scope.btnSubmitClick('SaveAndReload')
                                localStorage.setItem('activeName', 1)
                                if ($scope.vo.status < 2) {
                                    $scope.btnSubmitClick('Save')
                                }
                            }
                        } else {
                            this.$bus.emit('closeDoingDialog')
                        }
                    }
                } else {
                    this.$bus.emit('closeDoingDialog')
                    this.$alert(chkRes.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        }
    }
}
</script>

